import { PATH, makePath } from 'shared';
import { BASE_PATH_EDS } from './constants';
export const gotoAddInfo = (history) => {
    const slug = BASE_PATH_EDS + PATH.EDS.ADDITIONAL_INFO;
    const url = makePath(slug);
    history.push(url);
};
export const gotoDecline = (history) => {
    const slug = BASE_PATH_EDS + PATH.EDS.DECLINE;
    const url = makePath(slug);
    history.push(url);
};
export const gotoError = (history) => {
    const slug = BASE_PATH_EDS + PATH.EDS.ERROR;
    const url = makePath(slug);
    history.push(url);
};
export const gotoResult = (history) => {
    const slug = BASE_PATH_EDS + PATH.EDS.RESULT;
    const url = makePath(slug);
    history.push(url);
};
export const gotoApplications = (history) => {
    const slug = BASE_PATH_EDS + PATH.EDS.APPLICATION;
    const url = makePath(slug);
    history.push(url);
};
